import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import range from 'lodash/range';

const statics = {
  year: new Date().getFullYear(),
  month: new Date().getMonth(),
  date: new Date().getDate(),
  today: new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
  ),
};

const MonthDates = ({
  firstOfMonth,
  year,
  daysInMonth,
  startDay,
  weekNumbers,
  month,
  disablePast,
  minDate,
  onSelect,
  getDayStyle,
}) => {
  let day;
  let d;
  let current;
  let isDate;
  let className;
  let rows = 5;

  const weekStack = range(7);
  const localStartDay = firstOfMonth.getUTCDay();
  const first = firstOfMonth.getDay();
  const janOne = new Date(year, 0, 1);

  if (
    (localStartDay === 5 && daysInMonth === 31) ||
    (localStartDay === 6 && daysInMonth > 29)
  ) {
    rows = 6;
  }

  className = rows === 6 ? 'r-dates' : 'r-dates r-fix';
  const haystack = range(rows);
  day = startDay + 1 - first;
  while (day > 1) {
    day -= 7;
  }
  day -= 1;

  return (
    <div className="r-row r-weekdays">
      <div className={className}>
        {haystack.map((itemHey, j) => {
          d = day + j * 7;

          return (
            <div className="r-row" key={String(j)}>
              {weekNumbers && renderWeekNumber(year, month, janOne, d)}
              {weekStack.map((item, i) => {
                d += 1;
                isDate = d > 0 && d <= daysInMonth;
                const curDay = d;

                if (isDate) {
                  current = new Date(year, month, d);
                  className =
                    current !== statics.today
                      ? 'r-cell r-date'
                      : 'r-cell r-date r-today';
                  if (disablePast && current < statics.today) {
                    className += ' r-past';
                  } else if (minDate !== null && current < minDate) {
                    className += ' r-past';
                  }

                  if (/r-past/.test(className)) {
                    return (
                      <div
                        key={String(i)}
                        className={className}
                        role="button"
                        tabIndex="0"
                      >
                        {d}
                      </div>
                    );
                  }

                  return (
                    <div
                      key={String(i)}
                      className={`${className} ${getDayStyle(
                        moment([year, month, curDay]),
                      )}`}
                      role="button"
                      tabIndex="0"
                      onClick={event => onSelect(year, month, curDay, event)}
                    >
                      {d}
                    </div>
                  );
                }
                return <div className="r-cell" key={String(i)} />;
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const renderWeekNumber = (year, month, janOne, d) => {
  const wn = Math.ceil(
    ((new Date(year, month, d) - janOne) / 86400000 + janOne.getDay() + 1) / 7,
  );
  return <div className="r-cell r-weeknum">{wn}</div>;
};

MonthDates.propTypes = {
  firstOfMonth: PropTypes.object,
  year: PropTypes.number,
  daysInMonth: PropTypes.number,
  startDay: PropTypes.number,
  weekNumbers: PropTypes.bool,
  month: PropTypes.number,
  disablePast: PropTypes.bool,
  minDate: PropTypes.object,
  onSelect: PropTypes.func,
  getDayStyle: PropTypes.func,
};

export default MonthDates;



// WEBPACK FOOTER //
// ./src/components/Calendar/MonthDates.js